import { useSubscription } from '../../graphql';
import { useCurrentAccount } from '../../auth/hooks/useCurrentAccount';

export interface CallUpdate {
  id: string;
  room: string;
  state: string;
  caller: { id: string };
  callee: { id: string };
}

/**
 * Tracks lifecycle transitions (ACTIVE / DECLINED / ENDED / CANCELLED) for a
 * single call via the `updatedCall` subscription. Both the caller (waiting for
 * the callee to answer) and the callee (watching for a remote hang-up) use this.
 * Pass a falsy callId to disable.
 */
export const useCallUpdates = (
  callId: string | undefined,
  onUpdate: (call: CallUpdate) => Promise<void>
) => {
  const { account } = useCurrentAccount();

  useSubscription(
    {
      query: CALL_UPDATE_SUBSCRIPTION,
      variables: {
        filter: {
          id: { eq: callId },
        },
      },
    },
    async (response) => {
      await onUpdate(response.data.updatedCall);
    },
    account != null && callId != null
  );
};

const CALL_UPDATE_SUBSCRIPTION = `
subscription updatedCall($filter: CallSubscriptionFilter) {
  updatedCall(filter: $filter) {
    id
    room
    state
    caller {
      id
    }
    callee {
      id
    }
  }
}
`;
